module.exports = __webpack_public_path__ + "static/media/scatter.369e4f17.csv";